import React from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { ExtraServicePageImage } from "./InfoPage";

interface IProps {
  textData: string;
  setData: (data: string) => void;
  addImage?: (image: ExtraServicePageImage) => void;
}

let uploadImage;

const Editor: React.FC<IProps> = ({ textData, setData, addImage }) => {
  const custom_config = {
    extraPlugins: [MyCustomUploadAdapterPlugin],
    toolbar: {
      items: [
        "heading",
        "|",
        "bold",
        "italic",
        "link",
        "bulletedList",
        "numberedList",
        "|",
        "blockQuote",
        "insertTable",
        "|",
        "imageUpload",
        "undo",
        "redo",
      ],
      shouldNotGroupWhenFull: true,
    },
  };

  uploadImage = (image: ExtraServicePageImage) => {
    addImage && addImage(image);
  };

  return (
    <CKEditor
      editor={ClassicEditor}
      config={custom_config}
      data={textData}
      onChange={(event, editor) => {
        const data = editor.getData();
        setData(data);
      }}
    />
  );
};

function MyCustomUploadAdapterPlugin(editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
    return new MyUploadAdapter(loader);
  };
}

class MyUploadAdapter {
  protected loader: any;
  protected url: any;
  protected xhr: any;

  constructor(loader) {
    this.loader = loader;
    // URL where to send files.
    this.url = `http://localhost:17624/file/extra-service`;
  }

  // Starts the upload process.
  upload() {
    return new Promise((resolve, reject) => {
      this._initRequest();
      this._initListeners(resolve, reject);
      this._sendRequest();
    });
  }

  // Aborts the upload process.
  abort() {
    if (this.xhr) {
      this.xhr.abort();
    }
  }

  // Example implementation using XMLHttpRequest.
  _initRequest() {
    const xhr = (this.xhr = new XMLHttpRequest());
    const accessToken = localStorage.getItem("token");
    xhr.open("POST", this.url, true);
    xhr.responseType = "json";
    xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
    xhr.setRequestHeader("Authorization", `Bearer ${accessToken}`);
  }

  // Initializes XMLHttpRequest listeners.
  _initListeners(resolve, reject) {
    const xhr = this.xhr;
    const loader = this.loader;
    const genericErrorText = `Couldn't upload file: ${loader.file.name}.`;

    xhr.addEventListener("error", () => reject(genericErrorText));
    xhr.addEventListener("abort", () => reject());
    xhr.addEventListener("load", () => {
      const response = xhr.response;

      if (!response || response.error) {
        return reject(
          response && response.error
            ? response.error.message
            : genericErrorText,
        );
      }

      uploadImage({ fileId: response.id, preview: response.preview });
      resolve({
        default: response.preview,
      });
    });

    if (xhr.upload) {
      xhr.upload.addEventListener("progress", (evt) => {
        if (evt.lengthComputable) {
          loader.uploadTotal = evt.total;
          loader.uploaded = evt.loaded;
        }
      });
    }
  }

  // Prepares the data and sends the request.
  _sendRequest() {
    const data = new FormData();
    this.loader.file.then((result) => {
      data.append("file", result);

      this.xhr.send(data);
    });
  }
}

export default Editor;
